/*=========================================================================================
  File Name: i18nActiveStore.js
  Description: File đa ngôn ngữ cho kích hoạt mã misa store
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
	Author: NCThanh1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	TitleForm: 'Kích hoạt giấy phép sử dụng MISA mTax',
	ActiveKeyCode: 'Mã kích hoạt',
	MisaMtax: 'MISA mTax',
	PerYearUse: 'năm sử dụng',
	CompanyUse: 'Đơn vị sử dụng',
	TaxCode: 'Mã số thuế/CCCD',
	CompanyName: 'Tên công ty',
	Address: 'Địa chỉ',
	UserUsing: 'Người sử dụng',
	PhoneNumber: 'Số điện thoại',
	Email: 'Email',
	LastName: 'Họ và đệm',
	FirstName: 'Tên',
	NotKeyMtax: 'Mã kích hoạt không phải sản phẩm MISA mTax. Vui lòng kiểm tra lại.',
	ErrorFormalKey: 'Mã kích hoạt không hợp lệ. Vui lòng kiểm tra lại.',
	ErrorActiveKey: 'Mã kích hoạt đã được sử dụng. Vui lòng kiểm tra lại.',
	ErrorKeyMisaStore: 'Có lỗi trong quá trình xử lý. Vui lòng liên hệ MISA Store để được hỗ trợ',
	ActiveSuccessTitle: 'Kích hoạt giấy phép sử dụng thành công',
	ActiveSuccessSubTitle: 'Đã kích hoạt giấy phép sử dụng cho mã số thuế',
	ActiveSuccessDate: 'Hạn sử dụng đến',
	LoginNow: 'Đăng nhập ngay',
	NotSameTaxCode: 'Mã số thuế đang làm việc khác với mã số thuế mua trên MISA Store. Vui lòng kiểm tra lại.',
	ExistAccountMTax: 'Mã số thuế đã được kích hoạt. Vui lòng đăng nhập chương trình vào quản lý tài nguyên để kích hoạt lại',
	Organization: "Doanh nghiệp",
	Individual: "Cá nhân/Hộ kinh doanh"
};
